/* eslint-disable react/prop-types */
import React from 'react';
import { KIND_ORDER, SIGN_IN_KINDS } from './installsModel';

const pct = (share, total) => (total ? `${Math.round(share * 100)}%` : '—');

/** Four steps with the three drops between them; every item is a focus toggle. */
export default function StoryStrip({ story, focus, onFocus }) {
  const click = (key) => onFocus(focus === key ? 'first-open' : key);
  const items = [];
  story.steps.forEach((s, i) => {
    let note = null;
    if (i === 0) note = story.pending ? `${story.pending} still pending` : '';
    if (s.key === 'signed-in') {
      const parts = KIND_ORDER.filter((k) => story.kinds[k]).map((k) => (
        <span key={k} className={`inst-kind--${k}`}>{story.kinds[k]} {SIGN_IN_KINDS[k].tag}</span>
      ));
      note = parts.flatMap((p, j) => (j ? [' · ', p] : [p]));
    }
    items.push(
      <li className="inst-step" key={s.key}>
        <button type="button" aria-pressed={focus === s.key} onClick={() => click(s.key)} data-testid={`step-${s.key}`}>
          <div className="inst-step-label">{s.label}</div>
          <div>
            <span className="inst-step-count">{s.count}</span>
            {i > 0 && <span className="inst-step-pct">{pct(s.share, story.total)}</span>}
          </div>
          <div className="inst-step-note">{note}</div>
          <div className="inst-bar"><span style={{ width: `${story.total ? Math.round(s.share * 100) : 0}%` }} /></div>
        </button>
      </li>,
    );
    const d = story.drops[i];
    if (d) {
      items.push(
        <li className="inst-drop" key={d.key}>
          <button
            type="button"
            aria-pressed={focus === d.key}
            onClick={() => click(d.key)}
            title={`${d.story}: ${d.count} — ${d.pending} still inside the 48-hour window and may move on`}
            data-testid={`drop-${d.key}`}
          >
            <span className={`inst-drop-count${d.count ? '' : ' inst-drop-count--zero'}`}>{d.count}</span>
            <span className="inst-drop-label">{d.label}</span>
            {d.pending > 0 && <span className="inst-drop-pending">{d.pending} pending</span>}
          </button>
        </li>,
      );
    }
  });
  return <ol className="inst-story" aria-label="Install story">{items}</ol>;
}
